import React from 'react';
import { useSelector } from 'react-redux';
import { langSelector } from '../store/langSlice';

export default function CustomSelect({
  items,
  placeholder,
  value,
  isArabicStyle=true,
  setValue,
  isError,
  error
}) {
  const lang = useSelector(langSelector);
  return (
    <div style={{zIndex: 1000}}>
      <div className="relative">
        <select
          className={`appearance-none w-full font-inter font-medium text-2xl sm:text-3xl px-5 py-4 pr-10 ${isError ? 'mb-0' : 'mb-5'} rounded-[20px] border-2 focus:outline-none focus:border-primary ${isError ? 'border-primary' : 'border-gray'} ${value === '' && 'text-[#9ca3af]'}`}
          style={isArabicStyle ? {transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'} : {}}
          value={value}
          onChange={(e) => setValue(e.target.value)}
        >
          <option className='text-gray' style={isArabicStyle ? {transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'} : {}} disabled value=''>{placeholder}</option>
          {items.map((item) => {
            return (
              <option key={item.id} value={item.value} className='text-black' style={isArabicStyle ? {transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'} : {}}>{item.label}</option>
            );
          })}
        </select>
      </div>
      <p
        className={`relative mb-5 pl-5 font-medium text-xl text-primary ${isError ? 'block' : 'hidden'}`}
        style={isArabicStyle ? {transform: lang === 'ar' ? 'scaleX(-1)' : 'none', direction: lang === 'ar' ? 'rtl' : 'ltr'} : {}}>
          {error}
        </p>
    </div>
  );
}
